export default "__VITE_ASSET__BkEcOBE1__"